var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-dropdown"},[_c('div',{staticClass:"user-dropdown__wrapper"},[_c('div',{staticClass:"arrow-up"}),_c('p',{staticClass:"user-dropdown__link"},[_c('button',{staticClass:"user-dropdown__link--text",on:{"click":function($event){return _vm.signOut()}}},[_vm._v("Sign out")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }